"use strict";

import axios from "@/plugins/axios";

export const config = {
  namespaced: true,
  state: {
    config: {}
  },
  getters: {
    getConfig: state => state.config
  },
  mutations: {
    UPDATE_CONFIG: (state, payload) => (state.config = payload)
  },
  actions: {
    async getConfig({ commit }) {
      try {
        let config = (await axios.get("config")).data;

        config.tags.owner = {
          id: "owner",
          name: "Entwickler",
          hex: "#64B5F6",
          color: "blue  lighten-2",
          text_color: "blue--text  text-lighten-2"
        }


        commit("UPDATE_CONFIG", config);
      } catch (error) {
        return error;
      }
    }
  },

};
